import useReveal from "@/hooks/useReveal";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote: "We were using three different tools before LumeroFlow. Now our front desk manages bookings, I see my full patient history before each session, and my notes are drafted before I've even left the room. We run tighter days with less admin.",
    name: "Dr. Sarah Mitchell",
    role: "Clinic Owner, Kensington Physio",
    id: "clinic-owner",
  },
  {
    quote: "The AI note drafts capture about 90% of what I need. I spend a minute or two reviewing and adjusting, then save. What used to take me 15 minutes per patient now takes two. That's real time back in my day.",
    name: "James Thornton",
    role: "Osteopath, Brighton MSK Clinic",
    id: "osteopath",
  },
  {
    quote: "I manage four practitioners and their schedules. Since switching to LumeroFlow, our invoicing backlog is gone, patient records are actually up to date, and the team stopped asking me to chase missing notes.",
    name: "Emma Clarke",
    role: "Practice Manager, Restore Health",
    id: "practice-manager",
  },
];

const TestimonialsSection = () => {
  const [ref, isVisible] = useReveal();

  return (
    <section
      ref={ref}
      data-testid="testimonials-section"
      className="py-20 md:py-32"
      style={{ backgroundColor: "#FAF9F6" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`text-center mb-16 reveal-section ${isVisible ? "visible" : ""}`}>
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-[#205B5A] mb-5">
            Testimonials
          </p>
          <h2
            data-testid="testimonials-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight leading-tight text-[#1A1B1A] max-w-lg mx-auto"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            What clinics are saying
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className={`bg-white rounded-3xl border border-[#1A1B1A]/[0.05] p-8 md:p-10 shadow-sm flex flex-col reveal-section ${isVisible ? "visible" : ""}`}
              style={{ transitionDelay: `${i * 0.12}s` }}
            >
              <Quote className="w-8 h-8 text-[#205B5A]/20 mb-6 flex-shrink-0" />
              <p className="text-base text-[#1A1B1A] leading-relaxed mb-8 flex-grow">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#205B5A]/10 flex items-center justify-center">
                  <span className="text-sm font-semibold text-[#205B5A]">
                    {t.name.split(" ").map(n => n[0]).join("")}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#1A1B1A]">{t.name}</p>
                  <p className="text-xs text-[#757675]">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
